import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import {
  productListReducer,
  productDetailsReducer,
} from "./reducers/productReducers";
import { cartReducer } from "./reducers/cartReducers";
import {
  orderCreateReducer,
  orderTrackReducer,
  orderPayReducer,
  waiterCallReducer,
} from "./reducers/orderReducers";
import { restaurantDetailsReducer } from "./reducers/restaurantReducers";
import { languageReducer } from "./reducers/languageReducers";
import {
  availabilityReducer,
  reservationCreateReducer,
  eventsListReducer,
  eventDetailsReducer,
  eventReserveReducer,
  reservationLookupReducer,
  reservationCancelReducer,
} from "./reducers/reservationReducers";
import {
  productRecommendationsReducer,
  cartRecommendationsReducer,
} from "./reducers/upsellReducers";

const reducer = combineReducers({
  productList: productListReducer,
  productDetails: productDetailsReducer,
  cart: cartReducer,
  orderCreate: orderCreateReducer,
  orderTrack: orderTrackReducer,
  orderPay: orderPayReducer,
  waiterCall: waiterCallReducer,
  restaurantDetails: restaurantDetailsReducer,
  language: languageReducer,
  availability: availabilityReducer,
  reservationCreate: reservationCreateReducer,
  eventsList: eventsListReducer,
  eventDetails: eventDetailsReducer,
  eventReserve: eventReserveReducer,
  reservationLookup: reservationLookupReducer,
  reservationCancel: reservationCancelReducer,
  productRecommendations: productRecommendationsReducer,
  cartRecommendations: cartRecommendationsReducer,
});

const cartItemsFromStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const languageFromStorage = sessionStorage.getItem("tablify_lang") || "hu";

const initialState = {
  cart: { cartItems: cartItemsFromStorage },
  userLogin: { userInfo: userInfoFromStorage },
  language: { language: languageFromStorage },
};

const middleware = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
